import { SessionService } from 'app/services/session.service';
import { Component, OnInit, Input, Output, EventEmitter, HostBinding } from '@angular/core';
 
@Component({
    selector: 'app-notification',
    templateUrl: './wp-notifications.component.html',
    standalone: false
})
export class WpNotificationsComponent implements OnInit {
  @HostBinding('class.hideBanner') hideBanner = false;
  @Input() title: string;
  @Input() noTitle = false;
  @Input() centerDescription = false;
  @Input() showDismissBtn: boolean;
  @Input() autoDismiss: boolean;
  @Input() authcheck = false;
  @Input() tone: string;
  @Input() actionButtonText: string;
  @Input() actionButton: boolean = false;
  @Input() closeButton: boolean = false;
  @Input() dismiss: boolean = false;
  @Output('dismissAction') dismissNotification: EventEmitter<boolean> = new EventEmitter();
  hideNotification: boolean;
  dismissTimer = 5000;
  constructor(public sessionService: SessionService) {}

  ngOnInit() {
    if (this.autoDismiss) {
      setTimeout(() => this.onDismiss(), this.dismissTimer);
    }
    if (this.authcheck) {
      if (this.sessionService.getUserInfo() !== null) {
        this.hideBanner = true;
        return;
      }
    }
  }
  onDismiss() {
    this.hideNotification = true;
    this.dismissNotification.emit(true);
  }
  onClosedBanner(event: Event): void {
    this.hideNotification = true;
    this.dismissNotification.emit(true);
  }
}